import moment from 'moment';
import { v4 as uuid } from 'uuid';

export const generateImageFileNameWithRandomName = (file: any) => {
  try {
    const fileName =
      uuid() +
      moment(new Date()).format('DD-MM-yyyy-hh-mm-ss-SSS') +
      getFileExtensionName(file.name);
    const newFile = new File([file], fileName, {
      type: file.type,
    });
    return newFile;
  } catch (err) {
    return null!;
  }
};

const getFileExtensionName = (str: string) => {
  try {
    const patternFileExtension = /\.([0-9a-z]+)(?:[?#]|$)/i;
    const result = str.match(patternFileExtension)?.[0];
    return result;
  } catch (err) {
    return '.png';
  }
};
